import type { I18n } from '@change-corgi/core/i18n';
import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { PrefetchableComponentType, PrefetchContextData, PrefetchUserContextData } from 'src/shared/prefetch';

export type Options = {
	prefetchedData?: PrefetchContextData;
	prefetchedUserData?: PrefetchUserContextData;
	i18n?: I18n | UtilityContext['i18n'];
};

export type PageTitle = {
	title: string;
	originalTitle?: string;
};

export function getPageTitle(component: PrefetchableComponentType | undefined, options: Options): PageTitle {
	if (!options.i18n) {
		return getDefaultPageTitle(options);
	}
	if (!component || !component.prefetchName || !component.pageTitle) {
		return getDefaultPageTitle(options);
	}
	const res =
		component.pageTitle({
			i18n: options.i18n,
			prefetchedData: options.prefetchedData?.[component.prefetchName],
			prefetchedUserData: options.prefetchedUserData?.[component.prefetchName],
			fromTemplate,
		}) || getDefaultPageTitle(options);
	if (typeof res === 'string') {
		return {
			title: res,
		};
	}
	return res;
}

function getDefaultPageTitle(options: Options) {
	if (!options.i18n) {
		return { title: 'Change.org' };
	}
	return { title: `Change.org · ${options.i18n.translate('fe.pages.home.title')}` };
}

function fromTemplate(title: string): PageTitle {
	return {
		title: `${title} · Change.org`,
		originalTitle: title,
	};
}

export function getOriginalTitle(title: PageTitle): string {
	return title.originalTitle || title.title;
}
